<template>
    <div id="deliverable__in__project__list" style="padding-top: 1rem">
        <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="onDeliverableModalHide" @shown="onDeliverableModalShown">
			<EditModal :allContacts="allContacts"  ref="refEditModal" :tabIndex="tabIndexDeliverable"  :namespace="''" />
		</b-modal>
		<b-modal centered hide-footer id="createContactModal" title="New Contact" @shown="focusContactModal">
			<CreateContactModal ref="refContactModal" :namespace="namespace" />
		</b-modal>

		<b-modal hide-footer id="editContactModal" title="Update Contact" @shown="focusUpdateContactModal">
			<UpdateContactModal ref="refUpdateContactModal" :namespace="namespace" />
		</b-modal>

		<b-modal centered hide-footer id="createSpokespersonModal" title="New Spokesperson" @shown="focusSpokespersonModal">
			<CreateSpokespersonModal ref="refSpokespersonModal" :namespace="namespace" />
		</b-modal>
		<b-modal centered hide-footer id="createWhoModal" title="New Outlet / Contact" @shown="focusWhoModal">
			<CreateWhoModal ref="refWhoModal" :namespace="namespace" />
		</b-modal>

		<b-modal hide-footer id="editSpokespersonModal" title="Update Spokesperson" @shown="focusUpdateSpokespersonModal">
			<UpdateSpokespersonModal ref="refUpdateSpokespersonModal" :namespace="namespace" />
		</b-modal>
		<b-modal hide-footer id="editWhoModal" title="Update Outlet / Contact" @shown="focusUpdateWhoModal">
			<UpdateWhoModal ref="refUpdateWhoModal" :namespace="namespace" />
		</b-modal>

 		<CreateCfContactModal v-show="currentFieldKey!=''" ref="refCfContactModal" :namespace="namespace" />
		<UpdateCfContactModal v-show="currentFieldKey!=''" ref="refUpdateCfContactModal" :namespace="namespace" />

		<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable"
			class="modal-edit-social-deliverable" @hide="onSocialModalHide" @shown="onDeliverableModalShown">
			<EditSocialModal ref="refEditSocialModal" :namespace="namespace" :tabIndex="tabIndexSocial" />

		</b-modal>
		<b-modal no-close-on-backdrop no-close-on-esc size="xl" hide-footer
	      id="editOrganicSocialMediaPlanModal" class="modal-edit-deliverable"
	      @hide="onOrganicModalHide" @shown="onDeliverableModalShown" >
	      <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndexOrganic" :namespace="namespace" :suppressHighlightTabSwitch="suppressOrganicHighlightTabSwitch" />

	    </b-modal>
        <div
            class="deliverable-block project-block"
            :class="getDeliverableBlockClasses(deliverable)"
            v-for="(deliverable, index) in projectDeliverables"
            :key="'projectdeliverable-'+index+'-'+projectDetail.status"
            :id="'project__deliverable__' + deliverable.id"
        >
            <div class="delv-block-resp"
				:class="isParentProjectOnHold(deliverable.project_id) ? 'parent-project-on-hold' : ''">
            <DuplicateMediaCallFromProjectBtn :deliverableId='deliverable.id' :namespace="namespace" :deliverableTemplateId="deliverable.deliverable_template_id"/>
            <div class="d-flex flex-row dbox-wrapper">
                <div class="dbox-left-side dleft-inner-wrap">
                    <div class="top-row"
						:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
	                    <DeliverableDropdown 
							:deliverable="deliverable" 
							:deliverableTypes="deliverableTypes" 
							:classNames="''" />
                        <div class="data-items hide-mobile">
                            <DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
                        </div>
                        <div class="data-items hide-mobile" v-if="hasPriorityField(deliverable)">
                            <span class="">PRIORITY: </span>
                            <span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable)" :class="'listing-priority-del-'+deliverable.id">
                                <vue-star-rate
                                    :rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
                                    :maxIcon="5"
                                    :iconHeight="17"
                                    :iconWidth="17"
                                    :hasCounter="false"
                                    :key="'del-rating-'+Math.random()+deliverable.id"
                                    iconColor="var(--wf-primary)"
                                    iconColorHover="var(--wf-primary)"
                                    iconShape="circle"
                                ></vue-star-rate>
                            </span>
                        </div>
                        <template v-if="showAltStartEndDate(deliverable)">
							<div class="data-items hide-mobile" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'start_date'})" :key="'prj-deliverable-'+Math.random()">
								<span class="">START DATE:</span>
								{{ field.value | moment("DD MMM, YYYY @ H:mm") }}
							</div>
                            <div class="data-items hide-mobile" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'end_date'})" :key="'prj-deliverable-'+Math.random()">
								<span class="">END DATE:</span>
								{{ field.value | moment("DD MMM, YYYY @ H:mm") }}
							</div>
                            <div class="data-items" v-if="_.filter(deliverable.customFields, {field_key: 'start_date'}).length == 0">
								<span class="">START DATE:</span>
								No Date
							</div>
							<template v-if="calculateEndDate(deliverable) && _.filter(deliverable.customFields, {field_key: 'end_date'}).length == 0">
								<div class="data-items hide-mobile">
								<span class="">END DATE:</span>
								{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
								</div>
							</template>
							<template v-else>
								<template v-if="_.filter(deliverable.customFields, {field_key: 'end_date'}).length == 0">
									<div class="data-items hide-mobile">
										<span class="">END DATE:</span>
									No Date
									</div>
								</template>
							</template>
						</template>
                        <template v-else>
                            <div class="data-items">
                                <span class="hide-mobile">STARTED:</span>
                                {{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                            <div v-if="deliverable.all_completed" class="data-items">
                                <span class="hide-mobile">COMPLETED:</span>
                                {{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                            <div v-else class="data-items">
                                <span class="hide-mobile">LAST MODIFIED:</span>
                                {{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                        </template>
                    </div>
                    <DeliverableTypeIcon 
						:deliverableTypeId="deliverable.deliverable_template_id" 
						:deliverableProject="deliverable.project_id" />
                    <div class="row mobile-deli-info">
						<div class="data-items deliverable-priority" v-if="hasPriorityField(deliverable)">
							<span class="text-primary">PRIORITY: </span>
							<span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable, true)" :class="'listing-priority-del-'+deliverable.id">
								<vue-star-rate
									:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
									:maxIcon="5"
									:iconHeight="17"
									:iconWidth="17"
									:hasCounter="false"
									:key="'del-rating-'+Math.random()+deliverable.id"
									iconColor="var(--wf-primary)"
									iconColorHover="var(--wf-primary)"
									iconShape="circle"
								></vue-star-rate>
							</span>
						</div>
						<template v-if="showAltStartEndDate(deliverable)">
							<div class="data-items deliverable-start" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'start_date'})" :key="index">
								<span class="text-primary">START DATE:</span>
								{{ field.value | moment("DD MMM, YYYY") }}
							</div>
							<div class="data-items deliverable-start" v-if="_.filter(deliverable.customFields, {field_key: 'start_datetime'}).length == 0">
								<span class="text-primary">START DATE:</span>
								No Date
							</div>
							<div class="data-items deliverable-end">
								<span class="text-primary">END DATE:</span>
								<template v-if="calculateEndDate(deliverable)">
									{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
								</template>
								<template v-else>
									No Date
								</template>
							</div>
						</template>
						<template v-else>
							<div class="data-items deliverable-start">
								<span class="text-primary">STARTED:</span>
								{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-if="deliverable.all_completed" class="data-items deliverable-completed">
								<span class="text-primary">COMPLETED:</span>
								{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-else class="data-items deliverable-last-mod">
								<span class="text-primary">LAST MODIFIED:</span>
								{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
						</template>
						<div class="data-items no-padding deliverable-tags">
							<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
							 :namespace="namespace" @tag-created="updateDeliverableTags"  />
						</div>
						<div class="data-items deliverable-project">
							<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
						</div>
					</div>
                    <div class="row listing-row">
                        <div :class="` ${deliverable.total_unread_messages_in_conversation > 0 ? 'col-md-7' : 'col-md-8 titles '} breakpoint__fix `" 
							:style="infoColStyle(deliverable)">
                            <div class="inside-list department--wrap--new" v-if="showDepartment(deliverable)">
                                <DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
                            </div>
                            <div
                                class="deliverable-title edit-d-title"
                                @click="showModalFn(deliverable, false)"
                            >
                                <div v-b-tooltip.hover title="Remove from project" v-if="userCanEditDeliverable(deliverable)" class="option-bar" @click.stop="$root.$emit('showRemoveDeliverableFromProjModal', deliverable.id)">
                                    <span><i class="fas fa-trash"></i></span>
                                </div>
                                {{ deliverable.title }}
                                <span 
                                    v-if="deliverable.matching_posts_count > 0" 
                                    class="matching-posts-count"
                                    v-b-tooltip.hover 
                                    :title="deliverable.matching_posts_count + ' matching post(s) found'"
                                >({{ deliverable.matching_posts_count }})</span>
                            </div>
                            <div class="mobile-task-expand-button-area">
								<div class="mobile-task-exp-btn">
									<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expandAll" />
								</div>
							</div>
                        </div>
						<div 
							v-if="!isMobile() && 
							getSystemSetting('is_chat_enabled') &&
							deliverable.total_unread_messages_in_conversation > 0" 
							class="col-md-1 infos titles" 
							@click="showModalFn(deliverable, true)">
							<div class="d-flex flex-row">
								<ListMessageCounter :deliverable="deliverable" />
							</div>
						</div>
                        <div v-if="!isMobile()" class="col-md-4 infos">
                            <div class="d-flex flex-row">
                                <DeliverableListCoordinators 
								v-if="showInfoCol(deliverable) && getSystemSetting('media_call__show_owner')" 
								class="deliverable-list-coordinators" 
								:deliverable="deliverable" />

                                <DeliverableListContacts v-if="showInfoCol(deliverable)" class="deliverable-list-contacts" :deliverable="deliverable" />

                                <DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
								 :namespace="namespace" @tag-created="updateDeliverableTags"  />

                                <DeliverableStatusOverview :deliverable="deliverable" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div>
                                <b-collapse :visible="expandAll" :id="'task-listing-collapse-'+index" @shown="scrollToTaskAfterExpand(deliverable.tasks)">
                                    <div v-if="isMobile()" class="col-md-6 infos responsive-infos">
                                        <div class="d-flex flex-row">
                                        </div>
                                    </div>
                                    <TaskFieldLabels :fullDeliverables="projectDeliverables" :tasks="deliverable.tasks" :deliverableId="deliverable.id" :deliverable="deliverable" :namespace="namespace"/>
                                    <TaskFields :fullDeliverables="projectDeliverables" :deliverable="deliverable" :deliverableId="deliverable.id" :myWeek="false" :tasks="deliverable.tasks" :users="deliverable.users" :namespace="namespace"/>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dbox-right-side dright-inner-wrap">
                    <CollapseTaskBtn :deliverable="deliverable" :expandAll="expandAll" :index="index" />
                </div>
            </div>

            </div>
        </div>
        <div v-if="projectDeliverables.length == 0">
            Project has no deliverables assigned to it yet.
        </div>
        <div class="pagination-wrapper">
            <pagination :data="allProjectDeliverablesPaginationData" @pagination-change-page="onChangePage" :limit="5"></pagination>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ProjectCustomFields from "../common/ProjectCustomField";
import EditProjectModal from "./EditProjectModal"
import ProjectDatesRibbon from "./ProjectDatesRibbon";
import vueStarRate from "vue-js-star-rating";
import ProjectDepartments from "./ProjectDepartments";
import EditModal from "./EditModal";
import EditSocialModal from "./EditSocialModal.vue";
import EditOrganicSocialMediaPlanModal from "./EditOrganicSocialMediaPlanModal";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DuplicateMediaCallFromProjectBtn from "../common/DuplicateMediaCallFromProjectBtn";

import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';

import CreateCfContactModal from "./CreateCfContactModal";
import UpdateCfContactModal from "./EditCfContactModal";

import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableDropdown from "./DeliverableDropdown";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableType from "./DeliverableType";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import ListMessageCounter from "./ListMessageCounter";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import DeliverableStatusOverview from './DeliverableStatusOverview';

export default {
	props: {
        myWeek: false,
        filterQuery: '',
        expandAll: false,
        inProject:false,
        namespace:"",
    },
	data() {
		return {
			tabIndexDeliverable: 0,
			tabIndexOrganic: 0,
			tabIndexSocial: 0,
			suppressOrganicHighlightTabSwitch: false,
			isClosingFromRoute: false,
			openDeliverableModalCount: 0,
			notificationReturnUrl: null,
			fromNotificationsPendingReturn: false,
			suppressNextPopStateReturn: false,
			lastOpenDeliverableContext: null,
			suppressNextModalHistory: false,
			pendingModalRouteDeliverableId: null,
			isOpeningFromPopState: false,
			openingDeliverableId: null,
			lastPopStateDeliverableId: null,
			lastPopStateAt: 0,
			handledOpenDeliverableId: null,
			handledOpenDeliverableRoute: null,
		}
	},
    components: {
    	CreateCfContactModal,
		UpdateCfContactModal,
        ProjectCustomFields,
		AddProjectDeliverable,
		EditProjectModal,
		ProjectDatesRibbon,
		vueStarRate,
		ProjectDepartments,
		EditModal,
		EditSocialModal,
		EditOrganicSocialMediaPlanModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableDropdown,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		ListMessageCounter,
		DuplicateMediaCallFromProjectBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		DeliverableTypeIcon,
		DeliverableProjects,
		DeliverableType,
        DeliverableStatusOverview
    },
    methods: {
    	...mapActions({
    	  fetchProjects (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchProjects', payload)
    	  },
    	  fetchProjectDeliverable (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchProjectDeliverable', payload)
    	  },
    	  fetchUserManageProjects (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
    	  },
    	  fetchDeliverableUnreadMessageCount (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchDeliverableUnreadMessageCount', payload)
    	  },
    	}),
		...mapMutations({
			setDataLoading(commit, payload) {
				return commit(this.namespace + 'setDataLoading', payload)
			},
		}),
    	calculateEndDate(deliverable) {
    		let latestDueDate = null;

    		let end_date = _.filter(deliverable.customFields, { field_key: 'end_date' });
    		if (end_date.length > 0) {
    			return end_date[0].value;
    		}
    		let end_datetime = _.filter(deliverable.customFields, { field_key: 'end_datetime' });
    		if (end_datetime.length > 0) {
    			return end_datetime[0].value;
    		}
    		let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
    		if (publish_datetime.length > 0) {
    			return publish_datetime[0].value;
    		}

    		if (_.filter(deliverable.customFields, {field_key: 'end_date'}).length == 0) {
	    		if (deliverable.tasks && deliverable.tasks.length > 0) {
	    			deliverable.tasks.forEach(x => {
	    				const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
	    				if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
	    			});
	    		}
	    	}
    		return latestDueDate;
    	},

    	focusContactModal() {
    		this.$refs.refContactModal.focusMyElement();
    	},
    	focusUpdateContactModal() {
    		this.$refs.refUpdateContactModal.focusMyElement();
    	},
    	focusSpokespersonModal() {
    		this.$refs.refSpokespersonModal.focusMyElement();
    	},
    	focusUpdateSpokespersonModal() {
    		this.$refs.refUpdateSpokespersonModal.focusMyElement();
    	},
    	focusWhoModal() {
    		this.$refs.refWhoModal.focusMyElement();
    	},
    	focusUpdateWhoModal() {
    		this.$refs.refUpdateWhoModal.focusMyElement();
    	},


    	getDeliverableBlockClasses(deliverable) {
    		var classes = "";

    		if (this.isParentProjectOnHold(deliverable.project_id)) {
    			classes += " parent-project-on-hold";
    		}
    		if (!this.userCanEditDeliverable(deliverable)) {
    			classes += " read-only";
    		}

    		return classes;

    	},

    	isParentProjectOnHold(project_id) {
    		if (
    			project_id &&
    			project_id.project_status &&
    			project_id.project_status.slug &&
    			project_id.project_status.slug == 'on-hold'
    		) {
    			return true;
    		}
    		return false;
    	},

        userCanEditDeliverable(deliverable) {
            const userId = localStorage.getItem("userId");
            const project = this.projectDetail;

            if (this.userAbilities.accessAllProjects) {
                return true;
            }

            let isManager = false;
            if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
                isManager = userId == project.engagement_manager.id || userId == project.project_lead.id;
            } else {
                isManager = userId == project.engagement_manager || userId == project.project_lead;
            }

            return (this.userAbilities.editMediaCall && isManager);
        },
		onChangePage(page) {
			const query = { ...this.$route.query, page };
			this.$router.push({ query }).catch(() => {});
		},
		showModalFn(deliverable, openToChatTab) {
			let that = this;
			that.setDataLoading(true);
			// shows edit deliverable modal
			const deliverableId = deliverable.id;
			const deliverableTemplateSlug = that.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			this.lastOpenDeliverableContext = {
				deliverableId,
				openChildTask: false,
				isChat: openToChatTab === true,
				parentDeliverableId: null
			};
			if (
				openToChatTab == true &&
				(
					deliverableTemplateSlug == "marketing-project" ||
					deliverableTemplateSlug == "media-call" ||
					deliverableTemplateSlug == "media-event" ||
					deliverableTemplateSlug == "news-release" ||
					deliverableTemplateSlug == "writing-assignment"
				)
			) {
				// openToChatTab == true, clicked on unread message count chat bubble icon
				// Contact is tab1, Chat is tab2
				that.tabIndexDeliverable = 1;

			} else {
				that.tabIndexDeliverable = 0;
			}
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {

					const currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = that.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + that.deliverableDetail.title;
					}
					if (deliverableTemplateSlug === "organic-social-media-plan") {
						this.tabIndexOrganic = 1;
						const searchQuery = this.addProjectDeliverableFilter.query || '';
						if (searchQuery) {
							const currentFilter = this.$store.getters['relatedDeliverables/socialMediaFilter'];
							this.$store.commit('relatedDeliverables/setSocialMediaFilter', {
								...currentFilter,
								query: searchQuery
							});
						}
						that.$bvModal.show("editOrganicSocialMediaPlanModal");
					} else if (deliverableTemplateSlug === "social-media") {
						this.tabIndexSocial = openToChatTab ? 1 : 0;
						that.$bvModal.show("editSocialModal");
					} else {
						that.$bvModal.show("editDeliverableModal");
					}
					that.setDataLoading(false);
				});
		},

		onDeliverableModalShown() {
			this.openDeliverableModalCount += 1;
			if (this.suppressNextModalHistory) {
				this.suppressNextModalHistory = false;
				return;
			}
			this.pushRoute();
		},
		decrementDeliverableModalCount() {
			this.openDeliverableModalCount = Math.max(0, this.openDeliverableModalCount - 1);
			if (this.openDeliverableModalCount === 0 && !this.isClosingFromRoute) {
				const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
				if (baseState && baseState.modalOpen) {
					this.suppressNextPopStateReturn = true;
					history.back();
					return;
				}
				this.removeDeliverableFromUrl();
			}
		},
		pushRoute() {
			const overrideId = this.pendingModalRouteDeliverableId ? String(this.pendingModalRouteDeliverableId) : null;
			this.pendingModalRouteDeliverableId = null;
			const deliverableId = overrideId || (this.deliverableDetail && this.deliverableDetail.id ? String(this.deliverableDetail.id) : null);
			if (!deliverableId) {
				return;
			}
			const query = new URLSearchParams(window.location.search || '');
			const currentDeliverable = query.get('deliverable');
			const modalContext = this.lastOpenDeliverableContext ? { ...this.lastOpenDeliverableContext } : null;
			const parentRouteId = modalContext && modalContext.openChildTask && modalContext.parentDeliverableId
				? String(modalContext.parentDeliverableId)
				: null;
			const routeDeliverableId = parentRouteId || deliverableId;
			if (currentDeliverable === routeDeliverableId) {
				return;
			}
			query.set('deliverable', routeDeliverableId);
			const url = `${window.location.pathname}?${query.toString()}${window.location.hash || ''}`;
			const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
			if (baseState && baseState.fromNotifications) {
				const useReplace = !!(parentRouteId && currentDeliverable && currentDeliverable !== parentRouteId);
				const nextState = { ...baseState, modalOpen: true, modalContext };
				if (useReplace) {
					history.replaceState(nextState, null, url);
				} else {
					history.pushState(nextState, null, url);
				}
				return;
			}
			const useReplace = !!(parentRouteId && currentDeliverable && currentDeliverable !== parentRouteId);
			const nextState = { ...baseState, modalOpen: true, modalContext };
			if (useReplace) {
				history.replaceState(nextState, null, url);
			} else {
				history.pushState(nextState, null, url);
			}
		},
		onDeliverableModalHide(bvModalEvt) {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
			this.decrementDeliverableModalCount();
			if (this.isClosingFromRoute) {
				this.isClosingFromRoute = false;
				return;
			}
		},
		onSocialModalHide(bvModalEvt) {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
			this.decrementDeliverableModalCount();
			if (this.isClosingFromRoute) {
				this.isClosingFromRoute = false;
				return;
			}
		},
		onOrganicModalHide(bvModalEvt) {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
			this.decrementDeliverableModalCount();
			const currentFilter = this.$store.getters['relatedDeliverables/socialMediaFilter'];
			if (currentFilter.query) {
				this.$store.commit('relatedDeliverables/setSocialMediaFilter', {
					...currentFilter,
					query: ''
				});
			}
			if (this.isClosingFromRoute) {
				this.isClosingFromRoute = false;
				return;
			}
		},
		removeDeliverableFromUrl() {
			const query = new URLSearchParams(window.location.search || '');
			if (!query.has('deliverable') && !query.has('isChat') && !query.has('highlightTask') && !query.has('templateSlug')) {
				return;
			}
			query.delete('deliverable');
			query.delete('isChat');
			query.delete('highlightTask');
			query.delete('templateSlug');
			const url = `${window.location.pathname}${query.toString() ? `?${query.toString()}` : ''}${window.location.hash || ''}`;
			const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
			history.replaceState({ ...baseState }, null, url);
		},
		openDeliverableFromQuery(deliverableId, options = {}) {
			const deliverableKey = deliverableId != null ? String(deliverableId) : null;
			if (this.openingDeliverableId && deliverableKey && this.openingDeliverableId === deliverableKey) {
				return;
			}
			this.openingDeliverableId = deliverableKey;
			let that = this;
			that.setDataLoading(true);
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					const currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = that.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + that.deliverableDetail.title;
					}
					const deliverableTemplateSlug = that.getDeliverableTemplateSlug(parseInt(that.deliverableDetail.deliverable_template_id));
					const openChildTask = typeof options.openChildTask === 'boolean' ? options.openChildTask : this.$route.query.openChildTask === "1";
					const openChatTab = typeof options.isChat === 'boolean' ? options.isChat : this.$route.query.isChat === "1";
					if (deliverableTemplateSlug === "social-media" && openChildTask) {
						const childDeliverableId = deliverableId;
						const parentDeliverableId = this.deliverableDetail.parent_deliverable_id;
						this.lastOpenDeliverableContext = {
							...(this.lastOpenDeliverableContext || {}),
							deliverableId: childDeliverableId,
							openChildTask: true,
							isChat: openChatTab,
							parentDeliverableId: parentDeliverableId || null
						};
						const openSocialModal = () => {
							this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId: childDeliverableId })
								.then(() => {
									this.tabIndexSocial = openChatTab ? 1 : 0;
									this.suppressNextModalHistory = true;
									this.$bvModal.show("editSocialModal");
								});
						};
						if (parentDeliverableId) {
							this.pendingModalRouteDeliverableId = parentDeliverableId;
							this.tabIndexOrganic = 1;
							this.$store.dispatch(this.namespace + "getParentDeliverableDetail", { deliverableId: parentDeliverableId })
								.then(() => {
									this.$bvModal.show("editOrganicSocialMediaPlanModal");
									setTimeout(openSocialModal, 1500);
								});
						} else {
							this.pendingModalRouteDeliverableId = childDeliverableId;
							this.$store.commit(this.namespace + "setParentDeliverableDetail", this.deliverableDetail);
							this.tabIndexOrganic = 1;
							this.$bvModal.show("editOrganicSocialMediaPlanModal");
							setTimeout(openSocialModal, 1500);
						}
					} else if (deliverableTemplateSlug === "organic-social-media-plan" && openChildTask) {
						const childDeliverableId = options.deliverableId && String(options.deliverableId) !== String(deliverableId)
							? options.deliverableId
							: null;
						this.lastOpenDeliverableContext = {
							...(this.lastOpenDeliverableContext || {}),
							deliverableId: childDeliverableId || deliverableId,
							openChildTask: true,
							isChat: openChatTab,
							parentDeliverableId: deliverableId
						};
						this.pendingModalRouteDeliverableId = deliverableId;
						this.tabIndexOrganic = 1;
						this.$bvModal.show("editOrganicSocialMediaPlanModal");
						if (childDeliverableId) {
							const openSocialModal = () => {
								this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId: childDeliverableId })
									.then(() => {
										this.tabIndexSocial = openChatTab ? 1 : 0;
										this.suppressNextModalHistory = true;
										this.$bvModal.show("editSocialModal");
									});
							};
							setTimeout(openSocialModal, 1500);
						}
					} else if (deliverableTemplateSlug === "organic-social-media-plan") {
						this.lastOpenDeliverableContext = {
							deliverableId,
							openChildTask: false,
							isChat: openChatTab,
							parentDeliverableId: null
						};
						this.tabIndexOrganic = 1;
						that.$bvModal.show("editOrganicSocialMediaPlanModal");
					} else if (deliverableTemplateSlug === "social-media") {
						this.lastOpenDeliverableContext = {
							deliverableId,
							openChildTask: false,
							isChat: openChatTab,
							parentDeliverableId: null
						};
						this.tabIndexSocial = 0;
						that.$bvModal.show("editSocialModal");
					} else {
						this.lastOpenDeliverableContext = {
							deliverableId,
							openChildTask: false,
							isChat: openChatTab,
							parentDeliverableId: null
						};
						that.$bvModal.show("editDeliverableModal");
					}
					that.setDataLoading(false);
					this.isOpeningFromPopState = false;
					this.openingDeliverableId = null;
				})
				.catch(() => {
					this.isOpeningFromPopState = false;
					this.openingDeliverableId = null;
				});
		},

        hasPriorityField(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
        showInfoCol(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		infoColStyle(deliverable) {
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
        showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

        scrollToTaskAfterExpand(tasks) {
            if (this.taskHighlighted) {
                let hasThisTask = false;
                tasks.forEach(x => {
                    if (x.id == this.taskHighlighted) {
                        hasThisTask = true;
                    }
                });

                if (hasThisTask) {
                    const taskElOffset2 = $(".task-fields .field-block .task__title__" + this.taskHighlighted).offset();
                    window.scrollTo({top: taskElOffset2.top - 195, behavior: 'smooth'});
                }
            }
        },
		updateDeliverableTags(updatedDeliverableId) {
			let deliverableToUpdate;
			if (this.projectDeliverables instanceof Array) {
				deliverableToUpdate = this.projectDeliverables.find(x => x.id == updatedDeliverableId);
			} else {
				for (let i of Object.keys(this.projectDeliverables)) {
					deliverableToUpdate = this.projectDeliverables[i].find(x => x.id == updatedDeliverableId);
					if (deliverableToUpdate != null) break;
				}
			}
			if (deliverableToUpdate != null) {
				deliverableToUpdate.tags = this.deliverableDetail.tags;
			} else {
				console.error(`DeliverablesInProjectList Deliverable with ID ${updatedDeliverableId} not found.`);
			}
		},
		isParentProjectOnHold(project_id) {
			if (
				project_id &&
				project_id.project_status &&
				project_id.project_status.slug &&
				project_id.project_status.slug == 'on-hold'
			) {
				return true;
			}
			return false;
		},
		applyBackgroundColorIfOnHold(project_id) {
            if (
                project_id &&
                project_id.project_status &&
                project_id.project_status.color &&
                project_id.project_status.slug &&
                project_id.project_status.slug == 'on-hold'
            ) {
                return { backgroundColor: project_id.project_status.color };
            }
            return {};
        },
        /**
         * Check for openDeliverable query parameter and open the deliverable modal
         * This is used when coming from notification page
         */
        checkOpenDeliverableFromQuery() {
            const openDeliverableId = this.$route.query.openDeliverable;
            const highlightTaskId = this.$route.query.highlightTask;
            const templateSlug = this.$route.query.templateSlug;
			const isChat = this.$route.query.isChat;
            let openChildTask = this.$route.query.openChildTask === "1";

            if (openDeliverableId) {
				if (this.handledOpenDeliverableId === String(openDeliverableId) &&
					this.handledOpenDeliverableRoute === this.$route.fullPath) {
					return;
				}
				this.handledOpenDeliverableId = String(openDeliverableId);
				this.handledOpenDeliverableRoute = this.$route.fullPath;
				const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
				this.lastOpenDeliverableContext = {
					deliverableId: openDeliverableId,
					openChildTask,
					isChat: isChat === "1",
					highlightTaskId,
					templateSlug
				};
				if (baseState && baseState.fromNotifications && baseState.returnUrl) {
					this.notificationReturnUrl = baseState.returnUrl;
					this.fromNotificationsPendingReturn = true;
					try {
						sessionStorage.setItem('csmNotificationReturnUrl', baseState.returnUrl);
						sessionStorage.setItem('csmFromNotificationsPendingReturn', '1');
					} catch (err) {}
				}
                // Fetch deliverable and show modal
                this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId: openDeliverableId })
                    .then(() => {
                        let currentTitle = document.title.match(/\(\d+\)\s/g);
                        if (!currentTitle) {
                            document.title = this.deliverableDetail.title;
                        } else {
                            document.title = currentTitle[0] + this.deliverableDetail.title;
                        }

						// Highlight task if specified (use component namespace)
						const scheduleTaskHighlight = () => {
							if (!highlightTaskId) {
								return;
							}
							setTimeout(() => {
								this.$store.dispatch(this.namespace + "highlightTask", highlightTaskId);
							}, 2000);
						};

                        // Determine which modal to show based on template slug
						const openChatTab = isChat === "1";
                        const deliverableTemplateSlug = templateSlug || this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
                        if (deliverableTemplateSlug === "social-media" && !openChildTask && !openChatTab) {
                        	openChildTask = true;
                        }
                        if (openChatTab && openChildTask) {
                        	openChildTask = false;
                        }

						if (openChatTab || deliverableTemplateSlug == "media-call") {
							this.tabIndexDeliverable = 1;
							this.tabIndexOrganic = 1;
						} else {
							this.tabIndexDeliverable = 0;
							this.tabIndexOrganic = 0;
						}

						console.log("Opening deliverable modal for ID:", this.deliverableDetail ,openDeliverableId, "with template slug:", deliverableTemplateSlug);

                        if (deliverableTemplateSlug == "social-media") {
							const childDeliverableId = openDeliverableId;
							const parentDeliverableId = this.deliverableDetail.parent_deliverable_id;
							const openSocialModal = () => {
								this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId: childDeliverableId })
									.then(() => {
										this.tabIndexSocial = openChatTab ? 1 : (openChildTask ? 0 : 0);
										console.log("tabIndexSocial", this.tabIndexSocial);
										this.suppressNextModalHistory = true;
										this.$bvModal.show("editSocialModal");
										scheduleTaskHighlight();
									});
							};

							if (parentDeliverableId) {
								this.lastOpenDeliverableContext = {
									...(this.lastOpenDeliverableContext || {}),
									deliverableId: childDeliverableId,
									openChildTask: true,
									isChat: openChatTab,
									parentDeliverableId: parentDeliverableId
								};
								this.pendingModalRouteDeliverableId = parentDeliverableId;
								this.suppressOrganicHighlightTabSwitch = openChildTask;
								this.tabIndexOrganic = openChildTask ? 1 : (openChatTab ? 1 : 0);
								this.$store.dispatch(this.namespace + "getParentDeliverableDetail", { deliverableId: parentDeliverableId })
									.then(() => {
										this.$bvModal.show("editOrganicSocialMediaPlanModal");
										setTimeout(openSocialModal, 1500);
									});
							} else {
								this.lastOpenDeliverableContext = {
									...(this.lastOpenDeliverableContext || {}),
									deliverableId: childDeliverableId,
									openChildTask: true,
									isChat: openChatTab,
									parentDeliverableId: null
								};
								this.pendingModalRouteDeliverableId = childDeliverableId;
								this.$store.commit(this.namespace + "setParentDeliverableDetail", this.deliverableDetail);
								this.suppressOrganicHighlightTabSwitch = openChildTask;
								this.tabIndexOrganic = openChildTask ? 1 : (openChatTab ? 1 : 0);
								this.$bvModal.show("editOrganicSocialMediaPlanModal");
								setTimeout(openSocialModal, 1500);
							}
                        } else if (deliverableTemplateSlug == "organic-social-media-plan") {
                        	this.suppressOrganicHighlightTabSwitch = false;
                        	this.tabIndexOrganic = 1;
                        	this.$store.commit(this.namespace + "setParentDeliverableDetail", this.deliverableDetail);
                            this.$bvModal.show("editOrganicSocialMediaPlanModal");
                            scheduleTaskHighlight();

                        } else {
                        	this.suppressOrganicHighlightTabSwitch = false;
                            this.$bvModal.show("editDeliverableModal");
                            scheduleTaskHighlight();
                        }
                    })
					.catch(() => {});
            }
        },

		handlePopState(event) {
			if (this.suppressNextPopStateReturn) {
				this.suppressNextPopStateReturn = false;
				return;
			}
			const state = event && event.state ? event.state : null;
			const urlQuery = new URLSearchParams(window.location.search || '');
			const urlDeliverable = urlQuery.get('deliverable');
			const urlOpenDeliverable = urlQuery.get('openDeliverable');
			const hasNotificationParams = urlQuery.has('openDeliverable') ||
				urlQuery.has('openChildTask') ||
				urlQuery.has('highlightTask') ||
				urlQuery.has('isChat') ||
				urlQuery.has('templateSlug');
			if (urlOpenDeliverable) {
				if (!this.openDeliverableModalCount) {
					this.handledOpenDeliverableRoute = null;
					this.checkOpenDeliverableFromQuery();
				}
				return;
			}
			if (urlDeliverable) {
				if (!this.openDeliverableModalCount) {
					const modalContext = state && state.modalContext ? state.modalContext : this.lastOpenDeliverableContext;
					this.isOpeningFromPopState = true;
					this.lastPopStateDeliverableId = String(urlDeliverable);
					this.lastPopStateAt = Date.now();
					this.openDeliverableFromQuery(urlDeliverable, modalContext || {});
				}
				return;
			}
			if (!this.openDeliverableModalCount && !urlDeliverable && state && state.fromNotifications && state.returnUrl) {
				window.location.href = state.returnUrl;
				return;
			}
			const fallbackReturnUrl = this.notificationReturnUrl || (() => {
				try {
					return sessionStorage.getItem('csmNotificationReturnUrl');
				} catch (err) {
					return null;
				}
			})();
			const shouldReturnToNotifications = this.fromNotificationsPendingReturn || (() => {
				try {
					return sessionStorage.getItem('csmFromNotificationsPendingReturn') === '1';
				} catch (err) {
					return false;
				}
			})();
			if (!this.openDeliverableModalCount && !urlDeliverable && shouldReturnToNotifications && fallbackReturnUrl) {
				this.fromNotificationsPendingReturn = false;
				try {
					sessionStorage.removeItem('csmFromNotificationsPendingReturn');
				} catch (err) {}
				window.location.href = fallbackReturnUrl;
				return;
			}
			if (!this.openDeliverableModalCount && hasNotificationParams) {
				const returnUrl = (state && state.fromNotifications && state.returnUrl) ? state.returnUrl : this.notificationReturnUrl;
				const fallbackReturnUrlFromParams = returnUrl || (() => {
					try {
						return sessionStorage.getItem('csmNotificationReturnUrl');
					} catch (err) {
						return null;
					}
				})();
				if (fallbackReturnUrlFromParams) {
					window.location.href = fallbackReturnUrlFromParams;
					return;
				}
			}
			const query = this.$router.currentRoute.query;
			if (!query.deliverable) {
				this.$bvModal.hide("editDeliverableModal");
				this.$bvModal.hide("editSocialModal");
				this.$bvModal.hide("editOrganicSocialMediaPlanModal");	
			}
		}
    },
    computed: {
    	...mapGetters([
		"dataLoading",
		"systemSettings",
		"getSystemSetting",
		"getDeliverableTemplateSlug",
		"userAbilities",
		"deliverableTypes",
		"currentFieldKey",
		"addProjectDeliverableFilter",
	]),
		...mapState({
    		state (state) {
    		return state[this.namespace]
    		},
    		projects (state, getters) {
    		return getters[this.namespace + 'projects']
    		},
    		projectDeliverables (state, getters) {
    		return getters[this.namespace + 'projectDeliverables']
    		},
    		allProjectDeliverablesPaginationData (state, getters) {
    		return getters[this.namespace + 'allProjectDeliverablesPaginationData']
    		},
    		projectDetail (state, getters) {
    		return getters[this.namespace + 'projectDetail']
    		},
    		deliverableDetail (state, getters) {
    		return getters[this.namespace + 'deliverableDetail']
    		},
    		allContacts (state, getters) {
    		return getters[this.namespace + 'allContacts']
    		},
    		userAbilities (state, getters) {
    		return getters['userAbilities']
    		},
    		deliverableTypes (state, getters) {
    		return getters[this.namespace + 'deliverableTypes']
    		},
    		userHasProjects (state, getters) {
    		return getters[this.namespace + 'userHasProjects']
    		},
    		taskHighlighted (state, getters) {
    		return getters[this.namespace + 'taskHighlighted']
    		},
    	}),

        _() {
			return _;
		},
    },
    destroyed() {
        this.$root.$off('bv::modal::hide')
    },
	beforeDestroy() {
		window.removeEventListener("popstate", this.handlePopState);
	},
	mounted() {
        self = this
		const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
		if (baseState && baseState.fromNotifications && baseState.returnUrl) {
			this.notificationReturnUrl = baseState.returnUrl;
			this.fromNotificationsPendingReturn = true;
			try {
				sessionStorage.setItem('csmNotificationReturnUrl', baseState.returnUrl);
				sessionStorage.setItem('csmFromNotificationsPendingReturn', '1');
			} catch (err) {}
		}
        this.$root.$on('bv::modal::hide', function(bvEvent, modalId) {
			if(modalId == 'editDeliverableModal' ||
			   modalId == 'editOrganicSocialMediaPlanModal') {
				self.sortTasks({sortKey: false, deliverables: self.projectDeliverables, sortFields: true, namespace:self.namespace})
			}
		});
        if (!this.projects && !this.projects.length) {
            this.fetchProjects();
        }
        this.fetchUserManageProjects();
   
		// Check for openDeliverable query parameter to open deliverable modal from notification
        this.checkOpenDeliverableFromQuery();

		const deliverableId = this.$route.query.deliverable;
		const hasOpenDeliverable = !!this.$route.query.openDeliverable;
		if (deliverableId && !hasOpenDeliverable) {
			this.openDeliverableFromQuery(deliverableId);
		}
		window.addEventListener("popstate", this.handlePopState);
    },
	watch: {
		'$route.query.openDeliverable': function(newVal, oldVal) {
			if (newVal && newVal !== oldVal) {
				this.checkOpenDeliverableFromQuery();
			}
		},
		'$route.query.page': {
			handler(newPage, oldPage) {
				if (newPage !== oldPage) {
					const page = Number(newPage) || 1;
					this.setDataLoading(true);
					this.fetchProjectDeliverable(page).then(() => {
						this.setDataLoading(false);
					});
				}
			}
		},
		'$route.query.deliverable': {
			handler(newVal, oldVal) {
				if (newVal && newVal !== oldVal && !this.$route.query.openDeliverable) {
					if (this.isOpeningFromPopState) {
						this.isOpeningFromPopState = false;
						return;
					}
					const recentPopStateMatch = this.lastPopStateDeliverableId &&
						String(newVal) === this.lastPopStateDeliverableId &&
						(Date.now() - this.lastPopStateAt) < 2000;
					if (recentPopStateMatch) {
						return;
					}
					this.openDeliverableFromQuery(newVal);
				} else if (!newVal && oldVal) {
					this.isClosingFromRoute = true;
					this.$bvModal.hide("editDeliverableModal");
					this.$bvModal.hide("editSocialModal");
					this.$bvModal.hide("editOrganicSocialMediaPlanModal");
				}
			}
		},
		projectDeliverables: {
			handler(newItems, oldItems) {
				if (this.dataLoading) {
					// fetchDeliverables has completed, dataLoading = false, 
					// call count api only once after allDeliverables array has value
					if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
						// Call api when userDeliverables or userDeliverables properties change
						if (newItems.length > 0) {
							this.fetchDeliverableUnreadMessageCount();
						}
					}
				}
			},
			deep: true
		},
	},
}
</script>

<style>
.matching-posts-count {
    color: #28a745;
    font-weight: 400;
	margin-left: 1rem;
}
</style>

